<template>
  <div class="pmcs">
    <Fieldset class="p-shadow-8">
      <template #legend>
        <Dropdown
          class="p-shadow-8"
          v-model="form.bumper"
          :options="admins"
          optionLabel="AdminNo"
          optionValue="AdminNo"
          dataKey="Equipment"
          placeholder="Select a Bumper#"
          :filter="true"
          filterPlaceholder="Find Bumper #"
        />
      </template>
      <b>Submit your PMCSx!</b>
      <br />
      <Dropdown
        class="p-mt-2"
        v-model="form.status"
        :options="techStatus"
        style="width: 238px"
        optionLabel="name"
        optionValue="code"
        placeholder="Select a Tech Status"
      />

      <br />
      <div class="container">
        <!-- <FileUpload
          class="fileupload p-m-1"
          v-show="!uploading"
          name="demo[]"
          chooseLabel="Picture"
          mode="basic"
          :auto="true"
          :customUpload="true"
          @uploader="onUpload($event)"
        /> -->
        <!-- <input type="file" accept="image/png, image/jpeg" @change="onUpload($event)"> -->
        <div v-show="uploading"><ProgressBar :value="progress" /></div>
        <InputText
          type="text"
          class="p-text-uppercase p-m-1"
          style="width: 238px"
          placeholder="Fault Description"
          icon="p-input-icon-right"
          v-model="form.desc"
        />
        <Button v-if="Showbutton" @click="addFault()" class="add p-mt-2" icon="pi pi-plus" />
      </div>

      <div>
        <hr class="rounded" />
        <div>
          <div class="fault" v-for="(f, index) in faults" :key="index">
            <h4>{{ f.bumper }}</h4>
            <h2>{{ f.status }}</h2>
            <p class="p-text-uppercase">{{ f.desc }}</p>
            <!-- <p>Index: {{index}}</p> -->
            <Button icon="pi pi-trash" @click="removeFault(index)" />
          </div>
          <p v-show="faults.length < 1"><b>No faults yet, add one.</b></p>

          <Button
            type="button"
            label="Submit Your Faults"
            icon="pi pi-plus-circle"
            class="p-button-warning p-mr-3"
            @click="sendFaultstodb()"
            v-if="faults.length > 0"
          />

        </div>
      </div>
    </Fieldset>
    <br />
    <!-- <Fieldset class="p-shadow-8">
      <template #legend> Existing GCSS-Army Faults 
        
      </template>

<div class="GCSSfaults">ESR Loaded Faults</div>

  <div class="GCSSfault_list">Loaded by Maintenance Manager</div>

    <div class="GCSSfault">using fileupload</div>

      <div class="p-input-icon-right"></div>
    </Fieldset> -->
    <Toast position="bottom-center" />
  </div>
</template>

<script>
import InputText from "primevue/inputtext";
import Fieldset from "primevue/fieldset";
import Dropdown from "primevue/dropdown";
// import FileUpload from "primevue/fileupload";
import ProgressBar from "primevue/progressbar";
import { fb_auth, fb_storage, fb_db } from "../firebase";

export default {
  name: "PMCS",
  components: {
    Dropdown,
    Fieldset,
    InputText,
    // FileUpload,
    ProgressBar,
  },

  data() {
    return {
      progress: 0,
      uploading: false,
      rating: null,
      form: {
        bumper: null,
        status: null,
        desc: null,
        image: null,
      },
      techStatus: [
        {
          name: "Diagonal - /",
          code: "/",
        },
        {
          name: "Deadlined - X",
          code: "X",
        },
        {
          name: "Safety - E",
          code: "E",
        },
        {
          name: "Unknown - U",
          code: "U",
        },
        {
          name: "No Fault Found",
          code: "none",
        },
      ],
      faults: [],
    };
  },

  async mounted() {
    await this.$store.dispatch("getAdmins");
  },

  methods: {
    onUpload(e) {
      console.log("Uploading file....", e.files);
      this.uploading = true;
      let file = e.files[0];
      var uploadTask = fb_storage.child("uploads/" + file.name).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          this.progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + this.progress + "% done");
        },
        function (error) {
          // Handle unsuccessful uploads
        },
        function () {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log("File available at", downloadURL);
            // update some collection with this url
            fb_db.collection("faults").doc("DVkYRdF9aNCQl2BMVUKS").update({
              image: downloadURL,
            });
            this.uploading = false;
          });
        }
      );
    },
    addFault() {
      if (!this.form.bumper) {
        console.log("no bumper");
        this.$toast.add({
          severity: "warn",
          summary: "No bumper #",
          detail: "Please select a bumper number.",
          life: 3000,
        });
      } else if (!this.form.status) {
        console.log("no status");
        // toast here
      } else if (!this.form.desc) {
        console.log("no desc");
        // toast here
      } else {
        let temp_bumper = this.form.bumper;
        this.faults.push(this.form);
        this.form = {};
        this.form.bumper = temp_bumper;
      }
    },
    removeFault(index) {
      this.faults.splice(index, 1);
    },
    async sendFaultstodb() {
      let userRef = fb_db.collection("users").doc(fb_auth.currentUser.uid)
      let userData = await userRef.get()
      let user = userData.data()
      this.faults.forEach(async(f) => {
  // move to registration sign up page to set the PUIC and UIC on the user object
        // let puic = await fb_db.collection("uics").doc(user.uic).get()
        fb_db.collection("faults").add({
          techstatus: f.status,
          desc: f.desc,
          admin: f.bumper,
          created: new Date(),
          user: userRef,
          status: "Not Assigned",
          mechanic: null,
          puic: user.puic, 
          uic: user.uic,
        });
      });
      this.faults = [];
      this.$toast.add({
        severity: "success",
        summary: "Success",
        detail: "Faults Uploaded.",
        life: 3000,
      });
    },
    logoutUser() {
      fb_auth
        .signOut()
        .then(() => {
          //sign-out successful.
          this.$router.push({ path: "/" });
        })
        .catch(function (error) {
          //an error happened
          console.log(error);
        });
    },
  },
  computed: {
    admins() {
      return this.$store.state.uic_admins;
    },
    Showbutton(){
      return this.form.bumper && this.form.desc && this.form.status;
    }
  },
};
</script>

<style lang="scss" scoped>
.pmcs {
  color: #999999;
.GCSSfaults {
  .GCSSfault_list {
    .GCSSfault {
      width: 300px;
      background: #efefef;
      border-radius: 10px;
      margin: 10px;
      float: left;

      div {
        margin: 0px 5px;
        padding: 5px 15px;
        border-radius: 5px;
        // color: $white;
      }
    }
  }
}
  .fault {
    background: #efefef;
    border-radius: 10px;
    margin: 15px;
    padding: 5px;
    width: 400px;
    display: flex;
    justify-content: space-between;
  }
}

.container {
  display: flex;
  justify-content: center;
}

.add {
  height: 30px;
  justify-content: center;
}
</style>